@if (store.isCompleted()) {
  <div class="row">
    <div class="col-12 col-lg-4 d-flex flex-column filters-column">
      <apm-section-title title="{{ 445239 | apmTranslate }}"></apm-section-title>
      <div class="flex-grow-1 overflow-auto min-h-0">
        <apm-chiller-free-st-configuration-filters />
      </div>
      <div class="flex-shrink-0 pt-3">
        <apm-button variant="secondary" [disabled]="!filters().isFormValid()" (buttonClick)="confirmComponents()">
          {{ 456940 | apmTranslate }}
        </apm-button>
      </div>
    </div>
    <div class="col-12 col-lg-8">
      <apm-chiller-free-st-configuration-results />
    </div>
  </div>
}
